import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { isNull } from 'lodash'
import Spinner from '../../common/Spinner'
import ListCard from '../../common/ListCard'
import NoResults from '../../common/NoResults'
import ListCardVirtual from '../../common/ListCardVirtual'
import {
  parseQsArg,
  getLocationKey,
  adjustScrollToIndex,
  itemLink,
} from '../../utils'

import {
  loadWantedItemsOfOtherUser,
  loadMoreWantedItemsOfOtherUser,
  unloadWantedItemsOfOtherUser,
  putWantedItemsOfOtherUserInCache,
} from '../../actions'
import {
  getWantedItemsOfOtherUser,
  canLoadMoreWantedItemsOfOtherUser,
  getTotalWantedItemsOfOtherUser,
  getWantedItemsOfOtherUserLoading,
  getWantedItemsOfOtherUserScrollToIndex,
  getWorld,
  getCategory,
} from '../../selectors'

class UserWantedItems extends PureComponent {
  state = {
    scrollToIndex: undefined,
  }

  componentDidMount() {
    const { items, scrollToIndex } = this.props
    if (scrollToIndex && items) {
      // Living in a life of workaround
      this.setState({
        scrollToIndex: adjustScrollToIndex(scrollToIndex, items.length),
      })
    }
    this.props.loadWantedItemsOfOtherUser(
      {
        user_id: this.props.userInfo.id,
        cat_id: this.props.category ? this.props.category.id : null,
        world_id: this.props.world ? this.props.world.id : null,
      },
      getLocationKey(this.props.location)
    )
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.category !== this.props.category ||
      nextProps.world !== this.props.world
    ) {
      this.props.unloadWantedItemsOfOtherUser()
      this.props.loadWantedItemsOfOtherUser({
        user_id: nextProps.userInfo.id,
        cat_id: nextProps.category ? nextProps.category.id : null,
        world_id: nextProps.world ? nextProps.world.id : null,
      })
      // New shit, reset scroll index
      this.setState({ scrollToIndex: undefined })
    }
  }

  componentWillUnmount() {
    this.props.unloadWantedItemsOfOtherUser(false)
  }

  componentDidUpdate(prevProps, prevState) {
    // Scroll resetted can now purge it!
    if (prevState.scrollToIndex) {
      this.setState({ scrollToIndex: undefined })
    }
  }

  loadMore = () => {
    this.props.loadMoreWantedItemsOfOtherUser({
      user_id: this.props.userInfo.id,
      cat_id: this.props.category ? this.props.category.id : null,
      world_id: this.props.world ? this.props.world.id : null,
    })
  }

  goToItemDetail = (item, index) => {
    this.props.putWantedItemsOfOtherUserInCache({
      index,
      cacheKey: getLocationKey(this.props.location),
    })
    this.props.history.push(itemLink(item))
  }

  renderNoRows = () => {
    const { items, loading, counts, category, world, userInfo } = this.props

    if (!loading && !isNull(items) && items.length === 0) {
      return (
        <NoResults>
          Nessun oggetto.
          {' '}
          {counts &&
            counts.wantedItems > 0 &&
            (category || world) &&
            <Link to={`/user/${userInfo.username}/items/wanted`}>
              Mostra tutti
            </Link>}
        </NoResults>
      )
    }
    return null
  }

  render() {
    const { items, loading, canLoadMoreItems } = this.props
    return (
      <ListCardVirtual
        items={items}
        loading={loading}
        canLoadMoreItems={canLoadMoreItems}
        loadMore={this.loadMore}
        scrollToIndex={this.state.scrollToIndex}
        noRowsRenderer={this.renderNoRows}
        renderListCard={(item, index) => (
          <ListCard item={item} index={index} onClick={this.goToItemDetail} />
        )}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  counts: state.otherUser.counts.counts,
  userInfo: state.otherUser.info.data,
  items: getWantedItemsOfOtherUser(state, getLocationKey(ownProps.location)),
  totalItems: getTotalWantedItemsOfOtherUser(state),
  canLoadMoreItems: canLoadMoreWantedItemsOfOtherUser(state),
  loading: getWantedItemsOfOtherUserLoading(state),
  category: getCategory(state, parseQsArg(ownProps.location, 'category')),
  world: getWorld(state, parseQsArg(ownProps.location, 'world')),
  scrollToIndex: getWantedItemsOfOtherUserScrollToIndex(
    state,
    getLocationKey(ownProps.location)
  ),
})

export default connect(mapStateToProps, {
  loadWantedItemsOfOtherUser,
  loadMoreWantedItemsOfOtherUser,
  unloadWantedItemsOfOtherUser,
  putWantedItemsOfOtherUserInCache,
})(UserWantedItems)



// WEBPACK FOOTER //
// ./src/pages/User/UserWantedItems.js